module.exports = __webpack_public_path__ + "static/footer_logos_right-128f0288244ac11414a880532680f225.png";